<template>
  <div class="noData" :style="`top:${top}`">
    <div class="noDataImg"></div>
    <div class="noDataText">暂无相关信息...</div>
  </div>
</template>

<script>
export default {
  props: {
    top: {
      type: String,
      value: '0px'
    }
  }
};
</script>

<style scoped lang="scss">
.noData {
  position: relative;
  top: 0px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  .noDataImg {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/noDataImg.png") no-repeat;
    background-size: cover;
    width: 320px;
    height: 173px;
  }
  .noDataText {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NoData.vue